<template>
    <tr>
        <td>
            {{ item.full_name }}
            <small class="show">{{ item.email }}</small>
        </td>
        <td>
            <span>{{ item.last_request | pmlDate('DD/MM/YYYY HH:mm') }}</span>
            <span class="label label-warning" v-if="item.created_at === item.updated_at">{{ $t('awaiting_activation') }}</span>
        </td>
        <td class="t_center">
            <div v-if="member.id !== item.id">
                <pml-checkbox v-model="item.is_admin" @input="isAdmin"></pml-checkbox>
            </div>
            <div v-else>
                <pml-checkbox v-model="item.is_admin" :disabled="true"></pml-checkbox>
            </div>
        </td>
        <td class="t_center">
            <div v-if="member.id !== item.id">
                <div v-pml-tooltip="$t('inactivate')" v-pml-block="isLoading" v-if="item.active" @click.prevent="askToInactivate()">
                    <pml-switch v-model="item.active"></pml-switch>
                </div>
                <div v-pml-tooltip="$t('reactivate')" v-pml-block="isLoading" v-if="!item.active" @click.prevent="askToReactivate()">
                    <pml-switch v-model="item.active"></pml-switch>
                </div>
            </div>
            <div v-else>
                <pml-switch v-model="item.active" :disabled="true"></pml-switch>
            </div>
        </td>
    </tr>
</template>

<script>
    import Notify from '@/utils/helpers/notify'
    import { mapGetters } from 'vuex'
    import { trans } from '@/utils/helpers/translation'
    import { reactivate, inactivate, setAsAdmin, unsetAsAdmin } from '@/services/members'
    import { irreversible } from '@/utils/helpers/sweet-alert'
    import swal from 'sweetalert2'

    export default {
        name: 'MemberItem',
        props: [ 'item' ],
        data () {
            return {
                role: null,
                isLoading: false
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'roles': 'getRoles'
            })
        },
        methods: {
            isAdmin (val) {
                val ? this.setAsAdmin() : this.unsetAsAdmin()
            },
            setAsAdmin () {
                setAsAdmin(this.item.id)
                    .catch(() => {
                        this.item.is_admin = !this.item.is_admin
                        Notify.error(trans('_notifications.error'))
                    })
            },
            unsetAsAdmin () {
                unsetAsAdmin(this.item.id)
                    .catch(() => {
                        this.item.is_admin = !this.item.is_admin
                        Notify.error(trans('_notifications.error'))
                    })
            },
            askToInactivate () {
                irreversible()
                    .then((response) => (response.value) ? this.inactivate() : null)
            },
            inactivate () {
                this.isLoading = true

                inactivate(this.item.id)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            askToReactivate () {
                let $vm = this
                swal({
                    title: trans('very_good'),
                    text: trans('we_are_glade_he_will_be_back_tell_us_his_new_email'),
                    type: 'success',
                    input: 'text',
                    showCancelButton: true,
                    confirmButtonColor: '#5fbeaa',
                    cancelButtonColor: '#f05050',
                    inputPlaceholder: trans('enter_a_new_email'),
                    confirmButtonText: trans('confirmed'),
                    cancelButtonText: trans('cancel'),
                    allowOutsideClick: false,
                    showLoaderOnConfirm: true,
                    preConfirm (email) {
                        reactivate($vm.item.id, { email })
                            .then((response) => {
                                return (response.value) ? Notify.success(trans('_notifications.success')) : null
                            })
                            .catch(errors => {
                                const error = errors.response.data.errors.general ? errors.response.data.errors.general[0] : errors.response.data.errors.email[0]
                                Notify.error(error)
                            })
                            .then(() => {
                                swal.hideLoading()
                            })
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/members/Item.vue